import React, { useEffect, useState } from "react";
import AgoraRTC  from "agora-rtc-sdk-ng";

const appId = "c625ee1203af4148a97a4231eee6be2e"; // Replace with your actual Agora App ID
const token = "007eJxTYGBerijzdblV+4yNq/luu+Zyi3eoxM+MDr47167kCc/5jA8KDMlmRqapqYZGBsaJaSaGJhaJluaJJkbGhqmpqWZJqUapNyceTG8IZGRon7WHlZEBAkF8QQZnDz9dQ3MTA3NjM1MDC3MzEwYGAKkUIY8="; // Ideally, fetch this dynamically
const channelName = "CHN-1740736508764";
const AgoraCall = ({onLeave }) => {
    const [client, setClient] = useState(null);
    const [tracks, setTracks] = useState(null);

    useEffect(() => {
        const init = async () => {
            try {
                if (!channelName) return;
        
                const agoraClient = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });
                setClient(agoraClient);
        
                await agoraClient.join(appId, channelName, token, null);
                
                const [microphoneTrack, cameraTrack] = await AgoraRTC.createMicrophoneAndCameraTracks();
                await agoraClient.publish([microphoneTrack, cameraTrack]);
        
                setTracks([microphoneTrack, cameraTrack]);
        
                console.log("Joined channel and published tracks");
        
            } catch (error) {
                console.error("Error initializing Agora:", error);
            }
        };

        init();

        return () => {
            if (client) {
                tracks?.forEach(track => track.stop());
                client.leave();
            }
        };
    }, [channelName]);

    return (
        <div className="agora-container">
            <h2>Agora Video Call - {channelName}</h2>
            <button className="leave-btn" onClick={onLeave}>Leave Call</button>
        </div>
    );
};

export default AgoraCall;
